import config from '@/config/config.js';


import errorCode from '@/api/error-code.js'
import wordAddress from "../api/wordAddress.js";
import product from "../api/product.js";
import upload from "../api/upload.js";
import captcha from "../api/captcha.js";
import user from "../api/user.js";
import order from "../api/order.js";
import userFunds from "../api/userFunds.js";
import common from "../api/common.js";


//api方法合集
export default {
	errorCode: errorCode,
	SUCCESS: errorCode.SUCCESS,
	address: wordAddress,
	product: product,
	upload: upload,
	captcha: captcha,
	user: user,
	order: order,
	userFunds: userFunds,
	common: common,
	getErrorMessage(code) {
		return errorCode.getErrorMessage(code).message;
	},
}
